import React from 'react';
import { usePageMeta } from '../hooks/usePageMeta';
import { faqCategories } from '../data/faqs';
import { PageHero } from '../components/ui/PageHero';
import { Accordion } from '../components/ui/Accordion';
import { CtaBand } from '../components/ui/CtaBand';
export function FAQ() {
  usePageMeta('Frequently Asked Questions', 'Answers for employers, candidates and leaders about executive search, confidentiality, applications and timelines.');
  return <>
      <PageHero crumbs={[{
      label: 'FAQs'
    }]} kicker="Frequently asked questions" title="Clear answers, before you ask." intro="How recruitment works, what happens after you apply, how we protect confidentiality and how employers begin a search." data-id="element-930" data-mp="3g40rf916qu5d" />
      <section className="bg-ivory py-20" data-id="element-931" data-mp="3kz6i0l5j8wzs">
        <div className="container-page grid gap-12 lg:grid-cols-12" data-id="element-932" data-mp="2qp87ljfjzor">
          <nav aria-label="FAQ categories" className="lg:col-span-3" data-id="element-933" data-mp="3uv9lpvg193ou">
            <ul className="flex flex-wrap gap-2 lg:sticky lg:top-28 lg:flex-col lg:gap-1" data-id="element-934" data-mp="3ux45v7jhcrrv">
              {faqCategories.map(c => <li key={c.id} data-id="element-935" data-mp="1ufkgrxwt55cl">
                  <a href={`#${c.id}`} className="block rounded-md px-3 py-2 text-sm text-muted transition-colors duration-150 hover:bg-white hover:text-ink" data-id="element-936" data-mp="1ugvhtpyvbz00">
                    {c.label}
                  </a>
                </li>)}
            </ul>
          </nav>
          <div className="space-y-16 lg:col-span-9" data-id="element-937" data-mp="29dmnggz4y6y2">
            {faqCategories.map(c => <section key={c.id} id={c.id} aria-labelledby={`${c.id}-h`} className="scroll-mt-28" data-id="element-938" data-mp="2de6hvcsbqwgi">
                <h2 id={`${c.id}-h`} className="mb-6 font-display text-4xl font-semibold text-ink" data-id="element-939" data-mp="2i4wo0s8kr3c9">
                  {c.label}
                </h2>
                <Accordion items={c.items} data-id="element-940" data-mp="2n3q1iknv2ucf" />
              </section>)}
          </div>
        </div>
      </section>
      <CtaBand title="Still have a question?" text="Our consultants are happy to help." primary={{
      label: 'Contact us',
      to: '/contact'
    }} secondary={{
      label: 'Our process',
      to: '/process'
    }} data-id="element-941" data-mp="2s1rmxc8rf5r2" />
    </>;
}